import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 3a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1H4zm10 16h5V5H5v14h9z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.34 7c.394 0 .715.32.715.715v4.293a.715.715 0 01-1.431 0V9.439l-7.369 7.369a.715.715 0 11-1.001-1.016l7.354-7.361h-2.561a.715.715 0 110-1.431h4.292z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.715 17.054A.715.715 0 017 16.339v-4.293a.715.715 0 111.43 0v2.569l7.37-7.369a.715.715 0 111 1.016l-7.353 7.361h2.56a.715.715 0 010 1.431H7.716z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
